import {PremiumNotice as PremiumNoticeLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type PremiumNoticeProps = {
  premiumNoticeLetter: PremiumNoticeLetter;
};

const PremiumNotice = (props: PremiumNoticeProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.premiumNoticeLetter.insuredName} ddprivacy="mask"/>
      <CardField name={'Number of Months Until Due'} value={props.premiumNoticeLetter.numberOfMonthsTillDue} />
      <CardField name={'Owner Name'} value={props.premiumNoticeLetter.ownerName} ddprivacy="mask"/>
      <CardField name={'Policy Number'} value={props.premiumNoticeLetter.policyNumber} ddprivacy="mask"/>
      <CardField name={'Amount Due'} value={toMoneyValue(props.premiumNoticeLetter.amountDue)} />
      <CardField name={'Payable'} value={props.premiumNoticeLetter.payable} />
      <CardField name={'Due Date'} value={toFormattedDateAsUTC(props.premiumNoticeLetter.dueDate)} />
      <CardField name={'Address'} value={props.premiumNoticeLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
    </>
  );
};

export default PremiumNotice;
